import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ChevronDownIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ChevronDownIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M4 8.43366C4 8.6558 4.08479 8.87795 4.25437 9.04752L11.3861 16.1793C11.7253 16.5184 12.2747 16.5184 12.6139 16.1793L19.7456 9.04752C20.0848 8.70837 20.0848 8.15895 19.7456 7.81979C19.4065 7.48064 18.857 7.48064 18.5179 7.81979L12 14.3377L5.48208 7.81979C5.14293 7.48064 4.59351 7.48064 4.25435 7.81979C4.08478 7.98936 4 8.21153 4 8.43366Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ChevronDownIcon;
